import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

const CATEGORY_LINKS = {
  'fedtfrysning': { path: '/behandlinger/fedtfrysning', label: 'Læs mere om Fedtfrysning' },
  'ems træning': { path: '/behandlinger/ems-traening', label: 'Læs mere om EMS Træning' },
  'body roll': { path: '/behandlinger/body-roll', label: 'Læs mere om Body Roll' },
  'vip forløb': { path: '/kontakt', label: 'Spørg om skræddersyet VIP-forløb' },
};

export default function PriceList({ items = [], filterCategory = null }) {
  const filteredItems = filterCategory 
    ? items.filter(item => item.category?.toLowerCase() === filterCategory.toLowerCase())
    : items;

  // Group items by category if no filter is applied
  const categories = filterCategory 
    ? [filterCategory] 
    : ['Fedtfrysning', 'EMS Træning', 'Body Roll', 'VIP Forløb'];

  // State to track expanded / collapsed state for each category
  const [expandedCategories, setExpandedCategories] = useState(() => {
    // By default, start with all categories closed unless filterCategory is set
    return categories.reduce((acc, cat) => {
      acc[cat] = Boolean(filterCategory);
      return acc;
    }, {});
  });

  const toggleCategory = (cat) => {
    setExpandedCategories(prev => ({
      ...prev,
      [cat]: !prev[cat]
    }));
  };

  return (
    <div className="space-y-8">
      {categories.map((cat) => {
        const catItems = filteredItems.filter(
          item => item.category?.toLowerCase() === cat.toLowerCase()
        );

        if (catItems.length === 0) return null;

        const isExpanded = Boolean(expandedCategories[cat]) || Boolean(filterCategory);

        return (
          <div key={cat} className="space-y-4">
            {!filterCategory && (
              <button
                type="button"
                onClick={() => toggleCategory(cat)}
                className="w-full pb-4 flex items-center justify-between text-left group cursor-pointer focus:outline-hidden border-b border-taupe-border/80 hover:border-espresso/40 transition-colors"
                aria-expanded={isExpanded}
              >
                <h3 className="font-sans text-xl sm:text-2xl font-semibold text-espresso uppercase tracking-wider group-hover:text-accent-brown transition-colors">
                  {cat}
                </h3>
                <div className="flex items-center gap-3">
                  <span className="text-xs uppercase tracking-wider text-taupe group-hover:text-espresso font-semibold transition-colors">
                    {isExpanded ? 'Skjul' : 'Vis priser'}
                  </span>
                  <span className="w-8 h-8 flex items-center justify-center text-espresso group-hover:text-accent-brown transition-colors">
                    <i 
                      className={`fa-solid fa-chevron-down text-sm transition-transform duration-300 ${
                        isExpanded ? 'rotate-180' : ''
                      }`} 
                      aria-hidden="true" 
                    />
                  </span>
                </div>
              </button>
            )}

            {isExpanded && (
              <div className="space-y-4 pt-1">
                {CATEGORY_LINKS[cat.toLowerCase()] && (
                  <div className="flex justify-end">
                    <Link
                      to={CATEGORY_LINKS[cat.toLowerCase()].path}
                      className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-taupe hover:text-accent-brown transition-colors group"
                    >
                      <span>{CATEGORY_LINKS[cat.toLowerCase()].label}</span>
                      <i className="fa-solid fa-arrow-right text-[10px] transition-transform group-hover:translate-x-1" aria-hidden="true" />
                    </Link>
                  </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {catItems.map((item) => (
                  <div
                    key={item.id || item.title}
                    className="p-5 sm:p-6 transition-all flex flex-col justify-between bg-white border border-taupe-border/80 shadow-xs"
                  >
                    <div>
                      <div className="flex items-start justify-between gap-3 mb-2">
                        <h4 className="font-sans text-base sm:text-lg font-semibold text-espresso uppercase tracking-wider">
                          {item.title}
                        </h4>
                      </div>

                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-taupe mb-3">
                        {item.duration && (
                          <span className="flex items-center gap-1.5">
                            <i className="fa-regular fa-clock" aria-hidden="true" />
                            <span>Varighed: {item.duration}</span>
                          </span>
                        )}
                        {item.offer_note && (
                          <span className="text-espresso font-medium">
                            {item.offer_note}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="pt-4 border-t border-taupe-border/50 flex items-center justify-between gap-4 mt-2">
                      <div className="flex flex-col">
                        <span className="font-sans text-lg sm:text-xl font-bold text-espresso">
                          {item.price}
                        </span>
                      </div>

                      <a
                        href={item.booking_url || BOOKING_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-5 py-2.5 text-xs font-semibold uppercase tracking-wider transition-colors bg-sand hover:bg-sand-dark text-espresso border border-taupe-border/60 cursor-pointer"
                      >
                        <span>Book tid</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
                      </a>
                    </div>
                  </div>
                ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
